import iconEmployee from '../../assets/icon_employee.jpg';
import './EmployeeCard.css';

const safeText = (v, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

const EmployeeCard = ({ employee, handleEmployeeClick }) => {
  const avatarSrc = employee?.imageUrl || iconEmployee;
  const name = safeText(employee?.name, 'Employee');
  const email = safeText(employee?.email, '—');
  const empCode = safeText(employee?.employeeCode, '—');

  return (
    <button
      type="button"
      className="ec-card"
      onClick={() => handleEmployeeClick?.(employee)}
      aria-label={`View ${name}`}
    >
      <div className="ec-top">
        <div className='ec-img-id'>
          <div className="ec-avatar-wrap">
            <img src={avatarSrc} alt="" className="ec-avatar" />
          </div>

          <span className="ec-id-pill">ID: {empCode}</span>
        </div>
        <div className="ec-content">
          <div className="ec-header">
            <h3 className="ec-name">{name}</h3>
          </div>
          <p className="ec-email">{email}</p>
        </div>
      </div>

      <div className="ec-chevron">
          <i className="bi bi-chevron-right" />
        </div>
    </button>
  );
};

export default EmployeeCard;